module.exports = __webpack_public_path__ + "img/217.67d70d3a.png";